<template>
  <calm-modal
    :show="visible"
    size="lg"
    :show-footer="false"
    @update:show="onUpdateShow"
    @close="emitClose"
  >
    <!-- Calm header: title + id chip + cancel action -->
    <template slot="header">
      <div class="td-head">
        <h3 class="calm__modal__title">
          <i class="fas fa-file-invoice"></i>
          {{ $t("lmg.trans_detail") }}
          <span class="td-head__id c-mono" v-if="localDetail">#{{ localDetail.ID }}</span>
        </h3>
        <div class="td-head__right" v-if="localDetail">
          <span class="calm__pill calm__pill--danger" v-if="localDetail.Cancel == 1">
            <i class="fas fa-ban"></i> ยกเลิก
          </span>
          <button
            v-if="localDetail.Cancel == 0"
            class="c-btn c-btn--danger c-btn--sm"
            @click="$emit('cancel-trans', localDetail)"
          >
            <i class="fas fa-trash"></i> {{ $t("lmg.cancel_trans") }}
          </button>
        </div>
      </div>
    </template>

    <div class="td" v-if="localDetail">
      <!-- SECTION: Transaction Info -->
      <calm-form-section :title="'ข้อมูลรายการ'">
        <div class="td-grid">
          <div class="td-kv">
            <span class="td-kv__label">{{ $t("lmg.sale_date") }}</span>
            <span class="td-kv__value c-mono">{{ localDetail.SaleDateShow || "—" }}</span>
          </div>
          <div class="td-kv">
            <span class="td-kv__label">{{ $t("lmg.recorder") }}</span>
            <span class="td-kv__value">{{ ((localDetail.RecordPersonFName || "") + " " + (localDetail.RecordPersonLName || "")).trim() || "—" }}</span>
          </div>
          <div class="td-kv">
            <span class="td-kv__label">{{ $t("lmg.owner_person") }}</span>
            <span class="td-kv__value">{{ ((localDetail.OwnerPersonFName || "") + " " + (localDetail.OwnerPersonLName || "")).trim() || "—" }}</span>
          </div>
          <div class="td-kv">
            <span class="td-kv__label">{{ $t("lmg.customer") }}</span>
            <span class="td-kv__value">{{ ((localDetail.CustomerFname || "") + " " + (localDetail.CustomerLname || "")).trim() || "—" }}</span>
          </div>
        </div>
      </calm-form-section>

      <!-- SECTION: Customer Address -->
      <calm-form-section :title="'ที่อยู่ลูกค้า'">
        <div class="td-grid">
          <div class="td-kv td-kv--wide">
            <span class="td-kv__label">{{ $t("lmg.address_customer") }}</span>
            <span class="td-kv__value">{{ localDetail.CustomerAddress || "—" }}</span>
          </div>
          <div class="td-kv">
            <span class="td-kv__label">{{ $t("lmg.address_subdistrict") }}</span>
            <span class="td-kv__value">{{ localDetail.CustomerSubDistrict || "—" }}</span>
          </div>
          <div class="td-kv">
            <span class="td-kv__label">{{ $t("lmg.address_district") }}</span>
            <span class="td-kv__value">{{ localDetail.CustomerDistrict || "—" }}</span>
          </div>
          <div class="td-kv">
            <span class="td-kv__label">{{ $t("lmg.address_province") }}</span>
            <span class="td-kv__value">{{ localDetail.CustomerProvince || "—" }}</span>
          </div>
          <div class="td-kv">
            <span class="td-kv__label">{{ $t("lmg.address_zipcode") }}</span>
            <span class="td-kv__value c-mono">{{ localDetail.CustomerPostCode || "—" }}</span>
          </div>
        </div>
      </calm-form-section>

      <!-- SECTION: Insurance & Financial -->
      <calm-form-section :title="'ประกันและการเงิน'">
        <div class="td-grid">
          <div class="td-kv td-kv--full">
            <span class="td-kv__label">{{ $t("lmg.insure") }}</span>
            <span class="td-kv__value">{{ localDetail.InsuranceShowName || "—" }}</span>
          </div>
          <div class="td-kv">
            <span class="td-kv__label">{{ $t("lmg.trans_amount") }}</span>
            <span class="td-kv__value c-mono">{{ localDetail.Amount }}</span>
          </div>
          <div class="td-kv">
            <span class="td-kv__label">{{ $t("lmg.summary_amount") }}</span>
            <span class="td-kv__value c-mono">{{ localDetail.AmountAll }}</span>
          </div>
          <div class="td-kv">
            <span class="td-kv__label">{{ $t("lmg.tax_amount") }}</span>
            <span class="td-kv__value c-mono">{{ localDetail.TaxAmount }}</span>
          </div>
          <div class="td-kv">
            <span class="td-kv__label">{{ $t("lmg.whTax") }}</span>
            <span class="td-kv__value c-mono">{{ localDetail.WhTax }}</span>
          </div>
          <div class="td-kv">
            <span class="td-kv__label">{{ $t("lmg.discount") }}</span>
            <span class="td-kv__value c-mono">{{ localDetail.CommissionAmount }}</span>
          </div>
          <div class="td-kv">
            <span class="td-kv__label">{{ $t("lmg.net_amount") }}</span>
            <span class="td-kv__value c-mono">{{ localDetail.NetAmount }}</span>
          </div>
          <div class="td-kv">
            <span class="td-kv__label">{{ $t("lmg.moreDiscount") }}</span>
            <span class="td-kv__value c-mono">{{ localDetail.MoreDiscount }}</span>
          </div>
          <div class="td-kv">
            <span class="td-kv__label">{{ $t("lmg.extra_charge") }}</span>
            <span class="td-kv__value c-mono">{{ localDetail.ExtraCharge }}</span>
          </div>
          <div class="td-kv">
            <span class="td-kv__label">{{ $t("lmg.pay_amount") }}</span>
            <span class="td-kv__value c-mono">{{ localDetail.PayAmount }}</span>
          </div>
          <div class="td-kv">
            <span class="td-kv__label">{{ $t("lmg.comm_incentive") }}</span>
            <span class="td-kv__value c-mono">{{ localDetail.Incentive }}</span>
          </div>
          <div class="td-kv">
            <span class="td-kv__label">{{ $t("lmg.payment_comm") }}</span>
            <span class="td-kv__value c-mono">{{ localDetail.InitialCom }}</span>
          </div>
          <div class="td-kv">
            <span class="td-kv__label">{{ $t("lmg.ttype") }}</span>
            <span class="td-kv__value">{{ localDetail.TransactionTypeName || "—" }}</span>
          </div>
          <div class="td-kv">
            <span class="td-kv__label">{{ $t("lmg.comm") }}</span>
            <span class="td-kv__value">{{ localDetail.ComProfileName || "—" }}</span>
          </div>
        </div>
      </calm-form-section>

      <!-- SECTION: Policy & Product Detail -->
      <calm-form-section :title="'กรมธรรม์และรายละเอียด'">
        <div class="td-grid">
          <!-- Inline-editable policy number -->
          <div class="td-kv td-kv--full">
            <span class="td-kv__label">{{ $t("lmg.policy_number") }}</span>
            <div v-if="!editingPolicyNumber" class="td-inline">
              <span class="td-kv__value c-mono">{{ localDetail.PolicyNumber || "—" }}</span>
              <button class="td-icon" :title="$t('lmg.edit')" @click="beginEditPolicyNumber()">
                <i class="fas fa-pen"></i>
              </button>
            </div>
            <div v-else class="td-inline td-inline--edit">
              <input
                class="ed c-mono"
                v-model="editPolicyNumber"
                :disabled="savingPolicyNumber"
                @keyup.enter="savePolicyNumber()"
                @keyup.esc="cancelEditPolicyNumber()"
              />
              <button class="td-icon td-icon--confirm" :disabled="savingPolicyNumber" @click="savePolicyNumber()">
                <i class="fas fa-spinner fa-spin" v-if="savingPolicyNumber"></i>
                <i class="fas fa-check" v-else></i>
              </button>
              <button class="td-icon" :disabled="savingPolicyNumber" @click="cancelEditPolicyNumber()">
                <i class="fas fa-times"></i>
              </button>
            </div>
          </div>

          <!-- DataType 1: Motor -->
          <template v-if="localDetail.TransactionDataType == 1">
            <div class="td-kv"><span class="td-kv__label">{{ $t("lmg.car_model") }}</span><span class="td-kv__value">{{ localDetail.CarModel || "—" }}</span></div>
            <div class="td-kv"><span class="td-kv__label">{{ $t("lmg.chassis_number") }}</span><span class="td-kv__value c-mono">{{ localDetail.ChassisNumber || "—" }}</span></div>
            <div class="td-kv"><span class="td-kv__label">{{ $t("lmg.license_plate") }}</span><span class="td-kv__value c-mono">{{ localDetail.LicencePlate || "—" }}</span></div>
            <div class="td-kv"><span class="td-kv__label">{{ $t("lmg.car_year") }}</span><span class="td-kv__value c-mono">{{ localDetail.CarRegisterYear || "—" }}</span></div>
            <div class="td-kv"><span class="td-kv__label">{{ $t("lmg.insure_sum") }}</span><span class="td-kv__value c-mono">{{ localDetail.SumInsured }}</span></div>
            <div class="td-kv"><span class="td-kv__label">{{ $t("lmg.car_type") }}</span><span class="td-kv__value">{{ carTypeName(localDetail.Engine) }}</span></div>
          </template>

          <!-- DataType 2: Health -->
          <template v-if="localDetail.TransactionDataType == 2">
            <div class="td-kv"><span class="td-kv__label">{{ $t("lmg.insure_type") }}</span><span class="td-kv__value">{{ localDetail.InsuranceTypeDesc || "—" }}</span></div>
            <div class="td-kv"><span class="td-kv__label">{{ $t("lmg.insure_plan") }}</span><span class="td-kv__value">{{ localDetail.InsurancePlan || "—" }}</span></div>
            <div class="td-kv"><span class="td-kv__label">{{ $t("lmg.age") }}</span><span class="td-kv__value c-mono">{{ localDetail.CustomerAge }}</span></div>
            <div class="td-kv"><span class="td-kv__label">{{ $t("lmg.detail") }}</span><span class="td-kv__value">{{ localDetail.Detail || "—" }}</span></div>
            <div class="td-kv"><span class="td-kv__label">{{ $t("lmg.insure_sum") }}</span><span class="td-kv__value c-mono">{{ localDetail.SumInsured }}</span></div>
          </template>

          <!-- DataType 3: General Casualty -->
          <template v-if="localDetail.TransactionDataType == 3">
            <div class="td-kv"><span class="td-kv__label">{{ $t("lmg.insure_type") }}</span><span class="td-kv__value">{{ localDetail.InsuranceTypeDesc || "—" }}</span></div>
            <div class="td-kv"><span class="td-kv__label">{{ $t("lmg.billing_address") }}</span><span class="td-kv__value">{{ localDetail.BuildingAddress || "—" }}</span></div>
            <div class="td-kv"><span class="td-kv__label">{{ $t("lmg.code_disaster") }}</span><span class="td-kv__value c-mono">{{ localDetail.CodeDisaster || "—" }}</span></div>
            <div class="td-kv"><span class="td-kv__label">{{ $t("lmg.insure_sum") }}</span><span class="td-kv__value c-mono">{{ localDetail.SumInsured }}</span></div>
          </template>

          <!-- DataType 4: Motor Casualty -->
          <template v-if="localDetail.TransactionDataType == 4">
            <div class="td-kv"><span class="td-kv__label">{{ $t("lmg.car_model") }}</span><span class="td-kv__value">{{ localDetail.CarModel || "—" }}</span></div>
            <div class="td-kv"><span class="td-kv__label">{{ $t("lmg.chassis_number") }}</span><span class="td-kv__value c-mono">{{ localDetail.ChassisNumber || "—" }}</span></div>
            <div class="td-kv"><span class="td-kv__label">{{ $t("lmg.license_plate") }}</span><span class="td-kv__value c-mono">{{ localDetail.LicencePlate || "—" }}</span></div>
            <div class="td-kv"><span class="td-kv__label">{{ $t("lmg.insure_sum") }}</span><span class="td-kv__value c-mono">{{ localDetail.SumInsured }}</span></div>
            <div class="td-kv td-kv--full"><span class="td-kv__label">{{ $t("lmg.insurance_scope") }}</span><span class="td-kv__value">{{ localDetail.InsuranceScope || "—" }}</span></div>
          </template>

          <!-- DataType 5: Other -->
          <template v-if="localDetail.TransactionDataType == 5">
            <div class="td-kv"><span class="td-kv__label">{{ $t("lmg.insure_type") }}</span><span class="td-kv__value">{{ localDetail.InsuranceTypeDesc || "—" }}</span></div>
            <div class="td-kv"><span class="td-kv__label">{{ $t("lmg.insure_plan") }}</span><span class="td-kv__value">{{ localDetail.InsurancePlan || "—" }}</span></div>
            <div class="td-kv"><span class="td-kv__label">{{ $t("lmg.note") }}</span><span class="td-kv__value">{{ localDetail.Detail || "—" }}</span></div>
            <div class="td-kv"><span class="td-kv__label">{{ $t("lmg.insure_sum") }}</span><span class="td-kv__value c-mono">{{ localDetail.SumInsured }}</span></div>
          </template>
        </div>
      </calm-form-section>

      <!-- SECTION: Coverage & Status -->
      <calm-form-section :title="'ความคุ้มครองและสถานะ'">
        <div class="td-grid">
          <!-- Inline-editable protection dates -->
          <div class="td-kv td-kv--wide">
            <span class="td-kv__label">{{ $t("lmg.protection_date") }}</span>
            <div v-if="!editingDates" class="td-inline">
              <span class="td-kv__value c-mono">
                {{ localDetail.StartDateShow }} {{ $t("to") }} {{ localDetail.EndDateShow }}
              </span>
              <button class="td-icon" :title="$t('lmg.edit')" @click="beginEditDates()">
                <i class="fas fa-pen"></i>
              </button>
            </div>
            <div v-else class="td-inline td-inline--edit">
              <flat-picker
                :config="{ allowInput: true }"
                class="ed c-mono"
                style="max-width: 130px"
                v-model="editStartDate"
                :disabled="savingDates"
              ></flat-picker>
              <span class="td-dash">{{ $t("to") }}</span>
              <flat-picker
                :config="{ allowInput: true }"
                class="ed c-mono"
                style="max-width: 130px"
                v-model="editEndDate"
                :disabled="savingDates"
              ></flat-picker>
              <button class="td-icon td-icon--confirm" :disabled="savingDates" @click="saveDates()">
                <i class="fas fa-spinner fa-spin" v-if="savingDates"></i>
                <i class="fas fa-check" v-else></i>
              </button>
              <button class="td-icon" :disabled="savingDates" @click="cancelEditDates()">
                <i class="fas fa-times"></i>
              </button>
            </div>
          </div>
          <div class="td-kv">
            <span class="td-kv__label">{{ $t("status") }}</span>
            <span class="calm__pill calm__pill--success" v-if="localDetail.Status == 1"><i class="fas fa-check-circle"></i> สำเร็จ</span>
            <span class="calm__pill calm__pill--blue" v-else-if="localDetail.Status == 2"><i class="fas fa-clock"></i> กำลังดำเนินการ</span>
            <span class="calm__pill calm__pill--danger" v-else-if="localDetail.Status == 3"><i class="fas fa-ban"></i> ยกเลิก</span>
            <span class="calm__pill calm__pill--neutral" v-else>—</span>
          </div>
          <div class="td-kv">
            <span class="td-kv__label">{{ $t("lmg.trans_date") }}</span>
            <span class="td-kv__value c-mono">{{ localDetail.CreatedAtShow || "—" }}</span>
          </div>
        </div>
      </calm-form-section>

      <!-- SECTION: Notes & Cash Status -->
      <calm-form-section :title="'หมายเหตุและสถานะเงินสด'">
        <div class="td-grid">
          <div class="td-kv td-kv--wide">
            <span class="td-kv__label">{{ $t("lmg.note") }}</span>
            <span class="td-kv__value">{{ localDetail.Note || "—" }}</span>
          </div>
          <div class="td-kv">
            <span class="td-kv__label">{{ $t("lmg.cash_clear") }}</span>
            <span class="calm__pill calm__pill--success" v-if="localDetail.CashClear == 1"><i class="fas fa-check-circle"></i> ไม่มีเงินสดค้างที่พนักงาน</span>
            <span class="calm__pill calm__pill--danger" v-else-if="localDetail.CashClear == 2"><i class="fas fa-exclamation-triangle"></i> มีเงินสดค้าง</span>
            <span class="calm__pill calm__pill--neutral" v-else-if="localDetail.CashClear == 3"><i class="fas fa-money-bill-wave"></i> ไม่ใช้เงินสด ไม่มีเงินค้าง</span>
            <span class="calm__pill calm__pill--neutral" v-else>—</span>
          </div>
          <div class="td-kv" v-if="localDetail.CashClear == 2">
            <span class="td-kv__label">{{ $t("lmg.cash_clear_amount") }}</span>
            <span class="td-kv__value c-mono">{{ localDetail.CashNotClearAmount }}</span>
          </div>
        </div>
      </calm-form-section>
    </div>

    <template slot="footer" slot-scope="{ close }">
      <button type="button" class="c-btn c-btn--ghost ml-auto" @click="close">
        {{ $t("close") }}
      </button>
    </template>
  </calm-modal>
</template>

<script>
import { mapActions } from "vuex";
import swal from "sweetalert2";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

// Fixed lookup — same enum V1 defines inline.
const CAR_TYPES = [
  { ID: 1, Name: "รถยนต์ทั่วไป" },
  { ID: 2, Name: "รถยนต์ไฟฟ้า" },
];

export default {
  name: "TransactionDetailModal",
  components: { flatPicker },
  props: {
    show: { type: Boolean, default: false },
    transaction: { type: Object, default: null },
  },
  data() {
    return {
      localDetail: null,
      editingPolicyNumber: false,
      editPolicyNumber: "",
      savingPolicyNumber: false,
      editingDates: false,
      editStartDate: "",
      editEndDate: "",
      savingDates: false,
    };
  },
  computed: {
    visible() {
      return this.show;
    },
  },
  watch: {
    transaction: {
      immediate: true,
      handler(val) {
        // Clone so inline edits don't mutate the parent's row before save succeeds.
        this.localDetail = val ? { ...val } : null;
        this.cancelEditPolicyNumber();
        this.cancelEditDates();
      },
    },
  },
  methods: {
    ...mapActions({
      updatePolicyNumberAction: "TransactionV2/updatePolicyNumber",
      updateDateAction: "TransactionV2/updateDate",
    }),

    emitClose() {
      this.$emit("update:show", false);
      this.$emit("close");
    },

    // calm-modal emits update:show on overlay/esc/close-button — bridge it to
    // the parent's :show.sync without an intermediate v-model setter.
    onUpdateShow(val) {
      if (!val) this.emitClose();
    },

    carTypeName(id) {
      const m = CAR_TYPES.find((c) => c.ID == id);
      return m ? m.Name : "-";
    },

    beginEditPolicyNumber() {
      this.editPolicyNumber = this.localDetail.PolicyNumber || "";
      this.editingPolicyNumber = true;
    },
    cancelEditPolicyNumber() {
      this.editingPolicyNumber = false;
      this.editPolicyNumber = "";
    },
    async savePolicyNumber() {
      const next = (this.editPolicyNumber || "").trim();
      if (!next) {
        swal.fire({ icon: "warning", title: "กรุณาระบุหมายเลขกรมธรรม์", timer: 1500, showConfirmButton: false });
        return;
      }
      if (next === this.localDetail.PolicyNumber) {
        this.editingPolicyNumber = false;
        return;
      }
      this.savingPolicyNumber = true;
      try {
        await this.updatePolicyNumberAction({ ID: this.localDetail.ID, policy_number: next });
        this.localDetail.PolicyNumber = next;
        this.editingPolicyNumber = false;
        this.$emit("saved", { ID: this.localDetail.ID, PolicyNumber: next });
        swal.fire({ icon: "success", title: this.$t("edit_success"), timer: 1200, showConfirmButton: false });
      } catch (err) {
        const key = err && err.response && err.response.data && err.response.data.Msg;
        swal.fire({ icon: "error", title: key ? this.$t(key) : this.$t("edit_fail") });
      } finally {
        this.savingPolicyNumber = false;
      }
    },

    beginEditDates() {
      this.editStartDate = this.parseToYMD(this.localDetail.StartDate) || this.parseShowToYMD(this.localDetail.StartDateShow);
      this.editEndDate = this.parseToYMD(this.localDetail.EndDate) || this.parseShowToYMD(this.localDetail.EndDateShow);
      this.editingDates = true;
    },
    cancelEditDates() {
      this.editingDates = false;
      this.editStartDate = "";
      this.editEndDate = "";
    },
    async saveDates() {
      if (!this.editStartDate || !this.editEndDate) {
        swal.fire({ icon: "warning", title: "กรุณาเลือกวันที่ให้ครบถ้วน", timer: 1500, showConfirmButton: false });
        return;
      }
      if (new Date(this.editEndDate) < new Date(this.editStartDate)) {
        swal.fire({ icon: "warning", title: "วันสิ้นสุดต้องไม่ก่อนวันเริ่มต้น", timer: 1800, showConfirmButton: false });
        return;
      }
      this.savingDates = true;
      try {
        await this.updateDateAction({
          ID: this.localDetail.ID,
          start_date: this.editStartDate,
          end_date: this.editEndDate,
        });
        this.editingDates = false;
        this.$emit("saved", { ID: this.localDetail.ID, start_date: this.editStartDate, end_date: this.editEndDate });
        swal.fire({ icon: "success", title: this.$t("edit_success"), timer: 1200, showConfirmButton: false });
      } catch (err) {
        const key = err && err.response && err.response.data && err.response.data.Msg;
        swal.fire({ icon: "error", title: key ? this.$t(key) : this.$t("edit_fail") });
      } finally {
        this.savingDates = false;
      }
    },

    parseToYMD(value) {
      if (!value) return "";
      const d = new Date(value);
      if (isNaN(d.getTime())) return "";
      const yyyy = d.getFullYear();
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const dd = String(d.getDate()).padStart(2, "0");
      return `${yyyy}-${mm}-${dd}`;
    },
    parseShowToYMD(value) {
      if (!value) return "";
      const parts = String(value).split("/");
      if (parts.length !== 3) return "";
      const [dd, mm, yyyy] = parts;
      if (!dd || !mm || !yyyy) return "";
      return `${yyyy}-${mm.padStart(2, "0")}-${dd.padStart(2, "0")}`;
    },
  },
};
</script>

<style scoped>
/* ── Calm detail-modal chrome ──────────────────────────────────────────
 * The base Calm modal (calm__modal*) supplies the box, head, body, and
 * actions row. This block only styles the transaction-specific header
 * cluster and the read-only key/value grid that replaced the old
 * bootstrap base-input rows. Namespaced under .td*; additive. */

.td-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
}
.td-head .calm__modal__title {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
.td-head__id {
  color: var(--c-blue-deep);
  font-weight: 600;
  font-size: 0.85em;
}
.td-head__right {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

/* Section grid — responsive key/value layout. */
.td-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 14px 18px;
}
.td-kv {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}
.td-kv--wide { grid-column: span 2; }
.td-kv--full { grid-column: 1 / -1; }
.td-kv__label {
  font-size: 11.5px;
  color: var(--c-text-mute);
  letter-spacing: 0.02em;
}
.td-kv__value {
  font-size: 14px;
  color: var(--c-text);
  font-weight: 500;
  word-break: break-word;
}

@media (max-width: 900px) {
  .td-grid { grid-template-columns: repeat(2, 1fr); }
  .td-kv--wide,
  .td-kv--full { grid-column: 1 / -1; }
}
@media (max-width: 560px) {
  .td-grid { grid-template-columns: 1fr; }
}

/* Inline edit affordances (policy number + dates). */
.td-inline {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}
.td-inline .ed { max-width: 240px; }
.td-dash { color: var(--c-text-mute); }

.td-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  background: transparent;
  border: 0;
  color: var(--c-text-mute);
  border-radius: 6px;
  cursor: pointer;
  transition: background var(--c-fast) var(--c-ease), color var(--c-fast) var(--c-ease);
}
.td-icon:hover:not(:disabled) {
  background: var(--c-blue-soft);
  color: var(--c-blue-deep);
}
.td-icon:disabled { opacity: 0.4; cursor: not-allowed; }
.td-icon--confirm { color: var(--c-success); }
.td-icon--confirm:hover:not(:disabled) {
  background: var(--c-success-soft);
  color: var(--c-success);
}
</style>
